
import React, { Component, useState, useEffect, useRef } from 'react'
import useStateRef from 'react-usestateref';
import Helper from '../Helper'
import CbLoginModal from '../CbLogin/CbLoginModal';
import { Link } from 'react-router-dom';

export const CbForgotPasswordModal = () => {


    const [hasError, setHasError, setHasErrorRef] = useStateRef(false);
    const [errorMessage, setErrorMessage, setErrorMessageRef] = useStateRef("");
    const [successMessage, setSuccessMessage, setSuccessMessageRef] = useStateRef("");
    const [redirect, setRedirect, redirectRef] = useStateRef(false);
    const loginModalBtn = useRef('');
    function closeButton() {
        clearErrorMsg();
    }
    const clearErrorMsg = (e) => {
        document.getElementById("forgetPassword-success-message-div").classList.remove("d-block");
        document.getElementById("forgetPassword-success-message-div").classList.add("d-none");
        document.getElementById("forgetPassword-error-message-div").classList.remove("d-block");
        document.getElementById("forgetPassword-error-message-div").classList.add("d-none");
        var elems = document.querySelectorAll(".form-control");
        [].forEach.call(elems, function (el) {
            el.classList.remove("form-error");
        });
    }
    const validateForgetPasswordForm = (key, value) => {
        switch (key) {
            case "email":
                var result = Helper.isEmpty(value)
                var validation = "^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9-]+\\.)+[A-Za-z]{2,6}$";
                var regex = RegExp(validation);
                if (result) {
                    setHasError(true)
                    document.getElementById("forgetPassword-success-message-div").classList.remove("d-block");
                    document.getElementById("forgetPassword-success-message-div").classList.add("d-none");
                    document.getElementById("forgetPassword-error-message-div").classList.remove("d-none")
                    document.getElementById("forgetPassword-error-message-div").classList.add("d-block")
                    var emptyErrorMessage = document.getElementById("email_error_message")
                    emptyErrorMessage.innerHTML = "Email Address is a required field.";
                    document.getElementById("email").classList.add("form-error")
                } else if (!regex.test(value)) {
                    setHasError(true)
                    document.getElementById("forgetPassword-success-message-div").classList.remove("d-block");
                    document.getElementById("forgetPassword-success-message-div").classList.add("d-none");
                    document.getElementById("forgetPassword-error-message-div").classList.remove("d-none")
                    document.getElementById("forgetPassword-error-message-div").classList.add("d-block")
                    var emptyErrorMessage = document.getElementById("email_error_message")
                    emptyErrorMessage.innerHTML = "The email address does not appear to be valid. Please use the format name@domain.xxx.";
                    document.getElementById("email").classList.add("form-error")
                } else {
                    var emptyFirstName = document.getElementById("email_error_message")
                    emptyFirstName.innerHTML = "";
                    document.getElementById("email").classList.remove("form-error")
                }
                break;

            default:
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        // clearErrorMsg();
        //setShowCaptcha(false);
        //setIsLoading(false)
        setHasError(false)
        var actionUrl = event.target.getAttribute('action');
        var formId = event.target.id;

        var formData = new FormData(event.target);
        const formValue = Object.fromEntries(formData.entries());

        // Object.entries(formValue).map(([key, value], keyIndex) => {
        //     validateForgetPasswordForm(key, value)
        // })
        var email = formData.get("email")
        var successUrl = formData.get("successUrl")
        var errorUrl = formData.get("errorUrl")
        var resumePage = formData.get("resumePage")

        const inputMap = {
            email: email,
            successUrl: successUrl,
            errorUrl: errorUrl,
            resumePage: resumePage
        }
        if (!setHasErrorRef.current) {
            //setIsLoading(true)
            fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/${actionUrl}`, {
                method: 'POST',
                headers: new Headers({
                    "content-Type": "application/json",
                }),
                body: JSON.stringify(inputMap)
            }).then(res => res.json())
                .then(res => {
                    if (res.result === "success") {
                        // setIsLoading(false)
                        document.getElementById("forgot-password").reset();
                        const redirectUrl = res.response
                        var successMsg = res?.response;
                        if(successMsg?.includes('href')){
                            successMsg = successMsg?.replace('href="#"','class="live-chat-link"');
                        }
                        setSuccessMessage(successMsg)
                        document.getElementById("forgetPassword-error-message-div").classList.remove("d-block");
                        document.getElementById("forgetPassword-error-message-div").classList.add("d-none");
                        document.getElementById("forgetPassword-success-message-div").classList.remove("d-none");
                        document.getElementById("forgetPassword-success-message-div").classList.add("d-block");
                      

                    } else {
                        //  setIsLoading(false)
                        const error = res._ERROR_MESSAGE_;
                        setErrorMessage(error);
                        document.getElementById("forgetPassword-success-message-div").classList.remove("d-block");
                        document.getElementById("forgetPassword-success-message-div").classList.add("d-none");
                        document.getElementById("forgetPassword-error-message-div").classList.remove("d-none");
                        document.getElementById("forgetPassword-error-message-div").classList.add("d-block");
                        document.getElementById("email").classList.add("form-error")
                        //var emptyFirstName = document.getElementById("forgetPassword-message-error")
                        //emptyFirstName.innerHTML = setErrorMessageRef.current;

                    }
                })
        }

    }

    useEffect(() => {
        document.querySelector('#modalForgetPassword').addEventListener('hidden.bs.modal', function (e) {
            setSuccessMessage();
            var formElement = document.getElementById("forgot-password");
            formElement && formElement.reset();
            clearErrorMsg()
        })
    }, [])

    const handleLoginModal = ()=>{
        var formElement = document.getElementById("forgot-password");
        formElement && formElement.reset();
        loginModalBtn.current.click();
    }
    return (
        <>
            {/* <CbLoginModal triggerAddToList={false}/> */}
            <div><div class="modal fade" id="modalForgetPassword" tabindex="-1" aria-labelledby="exampleModalToggleLabel2" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        {/* <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> */}
                        <button type="button" id="FPModal" onClick={closeButton} class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                        </button>
                        <div class="modal-body modal-body-reset">

                            <div class="container-fluid login-modal-body">
                                <div class="row">
                                    <div class="col-12 mb-3">
                                        <h3 class="modal-title login mb-3" id="defaultModalLabel">Reset Password</h3>
                                        <p class="modal-sub-heading m-0">
                                            Enter the email address associated with your account and we will email instructions on how to reset your password
                                        </p>
                                    </div>

                                    <div className='row justify-content-conter'>
                                        <div class="col-12 mx-auto mt-md-4 mt-3">
                                            <div id="forgetPassword-success-message-div" className='d-none alert alert-success'>
                                                <div id="forgetPassword-success-message" dangerouslySetInnerHTML={{ __html: setSuccessMessageRef.current ? setSuccessMessageRef.current : "" }}></div>
                                            </div>
                                            <div id="forgetPassword-error-message-div" className='d-none alert alert-danger forgetPassword-error-message'>
                                                <div id="forgetPassword-error-message" dangerouslySetInnerHTML={{ __html: setErrorMessageRef.current }}></div>

                                                <div id="email_error_message"></div>

                                            </div>
                                        </div>
                                    </div>

                                    <form method="post" action="forgot-password" id="forgot-password" class="col-12 form reset-form" data-hs-cf-bound="true" onSubmit={handleSubmit} noValidate>
                                        <div style={{ display: 'none' }}>
                                            <input name="_dyncharset" type="hidden" value="UTF-8" />
                                        </div>
                                        <div style={{ display: 'none' }}>
                                            <input name="" type="hidden" />
                                        </div>
                                        {setSuccessMessageRef.current?
                                        ""
                                        :<div class="row mb-3 align-items-center">
                                            <label for="login-email" class="col-12 col-md-3 col-form-label">Email:</label>
                                            <div class="col-12 col-md-7">
                                                <input maxlength="256" name="email" id="email" type="email" class="form-control" />
                                            </div>
                                        </div>}
                                        <div class="row align-items-center form-submit">
                                            <div class="col-6 text-end">

                                            </div>

                                            <div class="col-6 text-end continue-btn">
                                                {setSuccessMessageRef.current?<button class="btn btn-primary login" data-bs-dismiss="modal" aria-label="Close">Continue</button>:
                                                <input type="submit" class="btn btn-primary login" value="Continue" />}
                                            </div>
                                        </div>
                                    </form>
                                    <button class="resetPwd-btn" onClick={handleLoginModal}>Log In</button>
                                    <button ref={loginModalBtn} type='hidden' data-bs-target="#loginModal" data-bs-toggle="modal" data-bs-dismiss="modal"></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div></div>

        </>
    )
}
